import Vue from 'vue';
import warehouseTransformer from './../../transformers/warehouse';
import store from './../../store';

const success = (data, resolve) => {
  store.dispatch('fetchCurrentWarehouse', warehouseTransformer.fetch(data));
  resolve(warehouseTransformer.fetch(data));
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  }
  reject(warehouseTransformer.fetch(errors));
};

export default (id, warehouse) => (
  new Promise((resolve, reject) => {
    Vue.$http.put(`/warehouses/${id}`, warehouse)
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/warehouse/update.js